var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress !== 0 && _vm.progress < 100 )?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-info progress-bar-striped",style:({width: _vm.getProgress}),attrs:{"role":"progressbar"}},[(_vm.progress < 101 && _vm.showProgressText)?_c('span',[_vm._v("\n      "+_vm._s(_vm.getProgress)+"\n    ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd865890","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload-progress.vue
// module id = 860
// module chunks = 4